var _path, _mask, _g, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCoupon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#BCD9C9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 12,
    width: 32,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8501 12.8667H39.4501V38H8.8501V12.8667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.287 36.7619H10.771C9.77711 36.7619 8.97168 35.7373 8.97168 34.4722V15.2802C8.97168 14.0156 9.77711 12.9905 10.771 12.9905H37.287C38.2805 12.9905 39.086 14.0156 39.086 15.2802V34.4722C39.086 35.7373 38.2805 36.7619 37.287 36.7619Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3999,
    y: 31.9333,
    width: 16.15,
    height: 1.73333,
    rx: 0.866667,
    fill: "#727D79"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3999,
    y: 27.6,
    width: 24.65,
    height: 1.73333,
    rx: 0.866667,
    fill: "#727D79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 12.75,
    width: 32.5,
    height: 24.5,
    rx: 3.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 16.75,
    width: 24.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#FF8B22",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCoupon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-coupon.b1304db4631a7b81edfc0152e96f4bab.svg";